import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import PanelHeader from '../../components/panelheader/panelHeader';
import * as css from './praksisstedsok.module.scss';
import translations from './praksisstedsok.i18n';

const PraksisstedsokHelp = () => {
  const { formatMessage } = useIntl();
  const labels = useMemo(
    () => ({
      helpTitle: formatMessage({
        id: translations.helpTitle.id,
      }),
      helpSubtitle: formatMessage({
        id: translations.helpSubtitle.id,
      }),
      avtale: formatMessage({
        id: translations.avtale.id,
      }),
      helpAvtaleParagraph: formatMessage({
        id: translations.helpAvtaleParagraph.id,
      }),
      bestilling: formatMessage({
        id: translations.bestilling.id,
      }),
      helpBestillingParagraph1: formatMessage({
        id: translations.helpBestillingParagraph1.id,
      }),
      helpBestillingParagraph2: formatMessage({
        id: translations.helpBestillingParagraph2.id,
      }),
      besvarelse: formatMessage({
        id: translations.besvarelse.id,
      }),
      helpBesvarelseParagraph: formatMessage({
        id: translations.helpBesvarelseParagraph.id,
      }),
      studentPraksisplassTitle: formatMessage({
        id: translations.studentPraksisplassTitle.id,
      }),
      helpTildeltePlasserParagraph: formatMessage({
        id: translations.helpTildeltePlasserParagraph.id,
      }),
      helpBrukereTilgangTitleParagraph: formatMessage({
        id: translations.helpBrukereTilgangTitleParagraph.id,
      }),
      helpBrukereTilgangParagraph: formatMessage({
        id: translations.helpBrukereTilgangParagraph.id,
      }),
    }),
    [formatMessage],
  );

  return (
    <PanelHeader
      title={labels.helpTitle}
      subtitle={labels.helpSubtitle}
      childrenClassName={css.praksisstedsokHelp}
      collapsible
    >
      <h3>{labels.avtale}</h3>
      <p>{labels.helpAvtaleParagraph}</p>
      <h3>{labels.bestilling}</h3>
      <p>{labels.helpBestillingParagraph1}</p>
      <p>{labels.helpBestillingParagraph2}</p>
      <h3>{labels.besvarelse}</h3>
      <p>{labels.helpBesvarelseParagraph}</p>
      <h3>{labels.studentPraksisplassTitle}</h3>
      <p>{labels.helpTildeltePlasserParagraph}</p>
      <h3>{labels.helpBrukereTilgangTitleParagraph}</h3>
      <p>{labels.helpBrukereTilgangParagraph}</p>
    </PanelHeader>
  );
};

export default PraksisstedsokHelp;
